<p>toggle-icon-input works!</p>
